export default "__VITE_ASSET__b05bde2e__"